import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resolveLocale } from '@/i18n';
import { PARTNER_LOCALES } from './locales';

/**
 * The promoter portal's i18n: ONLY its own `promoter.*` copy. Unlike the operator panel it does not merge the
 * portal files: it renders none of the portal screens, and 400 kB of dispatcher copy has no business on a
 * promoter's phone. The language choice is the shared one (`coreway.locale`, `resolveLocale`), and the shared
 * LocaleToggle switches this same i18next instance.
 */
export function initPartnersI18n(configured: string | null): typeof i18n {
  const lng = resolveLocale(configured);
  void i18n.use(initReactI18next).init({
    resources: { en: { translation: PARTNER_LOCALES.en }, es: { translation: PARTNER_LOCALES.es } },
    lng,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });
  document.documentElement.lang = lng;
  return i18n;
}
